<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">SEARCH</span>
    <span class="text-grey fs-3 fw-bold"> Phone Data</span>
    <br>
    <br>
    </div>
    
        <div class="row" style="min-width: 1000px;min-height: 600px;">
            <div class="col-4">
                <div class="row text-start" style="padding: 10px;border-radius: 15px;border: 1px solid grey;overflow-x: hidden;">
                    <table style="width: 100%;">
                      <tr>
                        <td rowspan="3" style="width:20%;text-align: center;">
                        <img src="https://cdn-icons-png.flaticon.com/512/552/552721.png" style="width:100px;"/>
                        </td>
                        <td style="width:80%;"><b>Name:</b>
                          {{ customerData.name_la }}
                        </td>
                      </tr>
                      <tr>
                          <td><b>Surname:</b>
                            {{ customerData.sirname_la }}
                          </td>
                      </tr>
                      <tr>
                          <td><b>Email:</b>
                            {{ customerData.email }}
                          </td>
                      </tr>
                      <tr>
                          <td colspan="2">
                            <!-- <span><b>Test444:</b> -->
                              <b>Address</b>
                              {{ 
                              (customerData.province?customerData.province+", ":'')+
                              (customerData.district?customerData.district+", ":'')+
                              (customerData.village_name?customerData.village_name:'')
                              }}
                            <!-- </span> -->
                          </td>
                      </tr>
                    </table>
                </div>
                <br>
                <div class="row text-start" style="border-radius: 15px;border: 1px solid grey;overflow-x: hidden;">
                  <div style="width: 100%;background-color: rgb(207, 205, 205);"><b>LTC Product</b></div>
                  <br>
                  <span><b>Product:</b>{{ customerLtcData.product }}</span> <br>
                  <span><b>Refilled:</b>{{ customerLtcData.refill }}</span> <br>
                  <span><b>Data Package:</b>???????</span> <br>
                  <span><b>Balance:</b>{{ (customerLtcData.balance?formatNumber(customerLtcData.balance):'') }}</span> <br>
                </div>
            </div>
            <div class="col-4 text-center">
              <div style="padding: 0px 10px 0px 10px;">
                  <div class="row">
                    <div class="col-10 text-end" style="padding:0px">
                      <input type="text" class="form-control" style="width: 100%;height: 35px;font-size: 12px;" placeholder="Customer Phonenumber..." v-model="phoneNumber" />
                    </div>
                    <div class="col-2 text-start" style="padding:0px">
                      <button type="button" @click="getCustPhoneData();" class="btn btn-success" style="width: 100%;">
                          <i class="fa-solid fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <br>
                  <div class="row text-start" style="border-radius: 15px;border: 1px solid grey;overflow-x: hidden;">
                    <div style="width: 100%;background-color: rgb(207, 205, 205)"><b>Personal Detail</b></div>
                    <br>
                    <span><b>Eduction:</b>{{ customerData.education }}</span> <br>
                    <span><b>Birth Date:</b>{{ customerData.dob }}</span> <br>
                    <span><b>Religion:</b>{{ customerData.religion }}</span> <br>
                    <span><b>Salary:</b>{{ customerData.salary }}</span> <br>
                    <span><b>Zodiac:</b>{{ customerData.zodiac }}</span> <br>
                    <span><b>Marriage Status:</b>{{ customerData.marriage_status }}</span> <br>
                    <span><b>Occupation:</b>{{ (customerData.occupation_id?getOccupationName(customerData.occupation_id):'-') }}</span> <br>
                  </div>
                </div>
            </div>
            <div class="col-4 text-start">
              <div class="row text-start" 
              style="width:100%;border-radius: 15px;border: 1px solid grey;overflow-x: hidden;">
                  <div style="width: 100%;background-color: rgb(207, 205, 205);"><b>Application Behavior</b></div>
                  <br>
                  <div style="width:100%;padding:0px;" v-for="(groupData,index) in behaviorArray" v-bind:key="index">
                    <div style="background-color: brown;width:100%;color:white">
                      &nbsp;<b>{{ groupData.groupName }}:</b>
                    </div> 
                    <div style="width:100%;display:flex;padding:5px; flex-wrap:wrap">
                    <div v-for="(behaviorData,index) in groupData.groupData" v-bind:key="index"> 
                      &nbsp;<img style="width:50px;border-radius: 5px;" :src="getImagePath(behaviorData.application_icon)"/>
                    </div>
                    </div>
                    <br>
                  </div>
                </div>
            </div>
        </div>      

    </div>
    
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
// import { Modal } from 'bootstrap'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';


export default {
  name: 'SurveyPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
        customerData:{},
        behaviorArray:[],
        phoneNumber:"",
        imagePathPrefix:'../assets/images/behavioral/',
        customerLtcData:{},
        occupations:{
            "occ1":"ນັ ກຮຽນ ",
            "occ2":"ນັ ກສຶ ກສາ ",
            "occ3":"ປະຊາຊົ ນ ",
            "occ4":"ກ ໍາາມະກອນ-ຮັ ບຈາງທົົ ວໄປ ",
            "occ5":"ຄ້ າ ຂ າ ຍ",
            "occ6":"ພະນັ ກງານລັ ດ",
            "occ7":"ພະນັ ກງານລັ ດວິ ສາຫະກິ ດ",
            "occ8":"ພະນັ ກງານເອກະຊົ ນ",
            "occ9":"ພະນັ ກງານກະສຽນບ ໍາານານ-ບ ໍາາເນັ ດ ",
            "occ10":"ເ ຈົ າ ຂ ອ ງ ທຸ ລ ະ ກິ ດ ",
            "occ11":"ອຶີ ນໆ ",
        }
    };
  },
  mounted:async function() {
  },
  methods: {
    // 
    clickSearch: function(){
      var vm = this;
      var phoneNumber = vm.phoneNumber
      vm.showLoading();
      Promise.all([vm.getCustomerDemographicByPhoneNo(phoneNumber), vm.getCustomerBehavior(phoneNumber)])
      .then(() => {
        setTimeout(() => {
          vm.hideLoading();
        }, 300);
      })
      .catch(() => {
        vm.hideLoading();
          console.log('One of the promises was rejected');
      });
    },
    getCustPhoneData: function(){
      var vm = this;
      vm.showLoading();
      var jsonRequest = {"phoneNumber":vm.phoneNumber};
      axios.post(Global.backendPath+"bigdata/getCustPhoneData", jsonRequest,
      {})
      .then((response) => {
        vm.hideLoading();
        console.log("getCustPhoneData",response);
        if(response.status==200&&response.statusText=="OK"){
          var results = response.data;
          var getCustomerBehavior= results.getCustomerBehavior;
          var getCustomerDemographicByPhoneNo = results.getCustomerDemographicByPhoneNo;
          var getLtcProductData = results.getLtcProductData;

          if(getCustomerDemographicByPhoneNo.statusName=="OK"){
            vm.customerData = getCustomerDemographicByPhoneNo.result;
          }else{
            vm.customerData = {};
          }

          if(getLtcProductData.statusName=="OK"){
            vm.customerLtcData = getLtcProductData.result[0];
          }else{
            vm.customerLtcData = {};
          }

          if(getCustomerBehavior.statusName=="OK"){
          var betterJsonModel = [];
          for(var idx=0;idx<getCustomerBehavior.result.length;idx++){
            var behaviorData = getCustomerBehavior.result[idx];
            if(idx==0||(idx>0&&behaviorData.application_group!=getCustomerBehavior.result[idx-1].application_group)){
              betterJsonModel.push({groupName:behaviorData.application_group,groupData:[behaviorData]});
            }else{
              betterJsonModel[betterJsonModel.length-1]["groupData"].push(behaviorData);
            }
          }
          vm.behaviorArray = betterJsonModel;
          }else{
            vm.behaviorArray = [];
          }

        }
      }).catch((error) => {
        console.log(error);
        // vm.isTokenExpire(error);
      });
    },
    getImagePath:function(filename) {
      try{
        return require(`../assets/images/behavioral/${filename}`);
      }catch(e){
        return require(`../assets/images/behavioral/NoImage.jpeg`);
      }
    },
    getOccupationName:function(id){
      return this.occupations["occ"+id];
    },
    formatNumber(number) {
      return Number(number).toLocaleString();
    }
    

  }
}
</script>
